<template>
  <div class="payment-blocked-view">
    <PaymentBlocked />
  </div>
</template>

<script>
import PaymentBlocked from '@/components/payment-regulation/PaymentBlocked.vue'

export default {
  name: 'PaymentBlockedView',

  components: {
    PaymentBlocked
  },

  beforeRouteLeave(to, from, next) {
    // Prevent leaving unless the payment issue has been resolved
    try {
      const raw = localStorage.getItem('user')
      if (raw && raw !== 'undefined') {
        const user = JSON.parse(raw)
        if (user && user._premium && user._premium.needAddPaymentMethod) {
          return next(false)
        }
      }
    } catch (e) { /* ignore */ }
    next()
  }
}
</script>

<style scoped>
.payment-blocked-view {
  min-height: 100vh;
}
</style>
